<template>
  <b-card style="overflow: auto">
    <router-view />
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";

export default {
  components: {
    BCard,
  },
};
</script>
